const legal = [
	{ href: "/legal", label: "Declaration of conformity" },
	{ href: "/terms", label: "Terms & conditions" },
	{ href: "/privacy", label: "Privacy statement" },
];

const socials = [
	{ href: "https://www.instagram.com/earsonly_/", icon: "/images/icons/instagram.svg", label: "Instagram" },
	{ href: "https://www.linkedin.com/company/earsonly/", icon: "/images/icons/linkedin.svg", label: "LinkedIn" },
];

export default function Footer() {
	return (
		<footer className="footer eo-footer">
			<div className="container eo-footer__grid">
				<nav aria-label="Legislation and regulations">
					<h2 className="eo-footer__title">Legislation and regulations</h2>
					<ul className="eo-footer__list">
						{legal.map((l) => (
							<li key={l.href}>
								<a href={l.href}>{l.label}</a>
							</li>
						))}
					</ul>
				</nav>
				<div>
					<h2 className="eo-footer__title">Visit</h2>
					<address className="eo-footer__address">
						Overcingellaan 7<br />
						9401 LA Assen<br />
						The Netherlands
					</address>
				</div>
				<div>
					<h2 className="eo-footer__title">Socials</h2>
					<div className="eo-footer__socials">
						{socials.map((s) => (
							<a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer" aria-label={s.label}>
								<img src={s.icon} alt="" />
							</a>
						))}
					</div>
				</div>
			</div>
			<div className="container eo-footer__bar">
				<a className="eo-footer__brand" href="/" aria-label="EarsOnly">
					<img src="/images/EarsOnly_Logo_FullColour_Black.svg" alt="EarsOnly" />
				</a>
				<span>&copy; EarsOnly 2026</span>
			</div>
		</footer>
	);
}
